<template>
  <div
    @click="selected"
    class="multimedia__content-grid-item"
    role="button">
    <img
      v-lazy="imageUrl"
      class="multimedia__content-grid-image"/>
    <div class="multimedia__content-grid-footer">
      <div class="multimedia__content-grid-footer-text">{{ filename }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    image: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(['token']),
    imageData() {
      return this.data ?? {};
    },
    imageUrl() {
      return this.imageData.url ? `${this.imageData.url}?token=${this.token}`
        : `${this.imageData.file}?token=${this.token}`;
    },
    filename() {
      return this.imageData.filename ?? 'file';
    },
    data() {
      return this.image.image ?? this.image.multimedia;
    },
  },
  methods: {
    selected() {
      this.$emit('selected', this.image);
    },
  },
};
</script>
